var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-3",attrs:{"height":"100%"}},[_c('h3',[_vm._v("Locations")]),(!_vm.loading)?_c('highcharts',{staticClass:"map",attrs:{"constructor-type":'mapChart',"options":_vm.mapOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }